import './App.css';
import BandeauGauche from './composants/BandeauGauche';
import BandeauDroite from './composants/BandeauDroite';
import Contenu from './composants/Contenu';
import config from './config';
import { setJeton, setListeThematiques, setListeCerclesProportionnel } from './redux/actions';
import { connect } from 'react-redux';
import { useEffect } from 'react';
import proj4 from 'proj4';
import { register } from 'ol/proj/proj4';
import Alerte from './composants/Alerte';
import { PublicClientApplication } from "@azure/msal-browser";
import { config_sso } from './config_sso';
import { MsalProvider } from '@azure/msal-react';
import MessageAlerte from './composants/MessageAlerte';
import { useMatomo } from '@datapunt/matomo-tracker-react' 

function App({ jeton, setListeCerclesProportionnel, setListeThematiques }) {

  const { trackPageView } = useMatomo()

  // Track page view
  useEffect(() => {
    trackPageView({
      documentTitle: 'Outils à la maille', // optional
      href: document.location.href, // optional
    })
  }, [])
  
  proj4.defs("EPSG:2154", "+proj=lcc +lat_1=49 +lat_2=44 +lat_0=46.5 +lon_0=3 +x_0=700000 +y_0=6600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs");
  register(proj4);

  const msalInstance = new PublicClientApplication(config_sso);

  // console.log(jeton)

  const request = {
    scopes: ['openid', 'profile', 'User.Read'],
    //sid: "2",
  }

  try {
    msalInstance.acquireTokenSilent(request)
      .then(loginResponse => {
        console.log(loginResponse)
      })
      .catch(error => {
        //console.log(error)
      })


  } catch (err) {
    /*
    if (err) {
      msalInstance.loginPopup(request)
        .then(loginResponse => {
          console.log(loginResponse);
        })
        .catch(error => {
          // handle error
        });
      } else {
        // handle error
      }
      */
  }

  //console.log(msalInstance)

  //Vérification si un compte n'est pas déja utilisé


  useEffect(() => {
    if (jeton !== "") {

      fetch(`${config.serveur}couchesmailles/{}`,
        {
          headers: {
            "Authorization": jeton
          }
        })
        .then(result => result.json())
        .then(result => {
          setListeThematiques(result);
        })

      fetch(`${config.serveur}bdd/maille/select id_indicateur AS id,* from maille.cercleproportionnel`)
        .then(result => result.json())
        .then(result => {
          setListeCerclesProportionnel(result);
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jeton])


  return (
    <MsalProvider instance={msalInstance}>
      <MessageAlerte/>
      <div className="App">
        <Alerte />
        <div id="bandeau">
          <BandeauGauche />
          <BandeauDroite />
        </div>
        <Contenu />
      </div>
    </MsalProvider>
  );
}


function mapStateToProps(state) {

  return {
    jeton: state.jeton,
  }
}

export default connect(mapStateToProps, { setListeThematiques, setListeCerclesProportionnel, setJeton })(App);
